<template>
    <div id="recharge-box" v-show="recharge">
        <div id="recharge-box-mj">
          <a href="javascript:;" class="close" id="recharge-close" @click="closeRecharge()"></a>
          <h3>确认支付方式</h3>
          <p class="name">金额</p>
          <p class="num">￥<span>{{rechargeAges.amount/100}}</span></p>
          <div class="list">
            <a
              :class="item.icon==='i-zhi'?'zhifubao':'wechat'"
              v-for="(item, index) in pay_list"
              :key="index"
              @click="item.icon === 'i-wechat' ? App_wxpay(item.url): App_alipay(item.url)"
            >
              <i class="icon" />
              <p>{{item.name}}</p>
            </a>
          </div>
        </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import configUrl from '../utility/config.js'
import FN from '../utility/fn.js'
export default {
  data () {
    return {
      pay_list: '',
      recharge: FN.isWX ? 0 : 1
    }
  },
  computed: {
    ...mapGetters(['rechargeAges'])
  },
  mounted () {
    this.rechargeList(this.rechargeAges)
  },
  methods: {
    App_alipay (url) {
      this.closeRecharge()
      setTimeout(function () {
        if (typeof mjWebview === 'object') {
          // 如果在马甲游渠道安卓内打壳
          mjWebview.clickZfb('http:' + configUrl.__gamepayDomain.get() + url)
        } else if (FN.isIOS) {
          // ios系统下支付
          try {
            // 如果在马甲游渠道IOS内打壳
            // 因为ios的PostMessage长度限制,所以就分两节
            let isoUrl = 'http:' + configUrl.__gamepayDomain.get() + url
            let url1 = isoUrl.substr(0, 800)
            let url2 = isoUrl.substr(800)
            window.webkit.messageHandlers.webViewApp.postMessage(url1) // ios壳子支付
            window.webkit.messageHandlers.webViewApp2.postMessage(url2) // ios壳子支付
          } catch (err) {
            window.location.href = url //  web跳转支付
          }
        } else {
          window.location.href = url //  web跳转支付
        }
      }, 500)
    },
    App_wxpay (url) {
      this.closeRecharge()
      setTimeout(function () {
        if (typeof mjWebview === 'object') {
          mjWebview.clickWx('http:' + configUrl.__gamepayDomain.get() + url)
        } else if (FN.isIOS) {
          try {
          // 因为ios的PostMessage长度限制,所以就分两节
            let isoUrl = 'http:' + configUrl.__gamepayDomain.get() + url
            let url1 = isoUrl.substr(0, 800)
            let url2 = isoUrl.substr(800)
            window.webkit.messageHandlers.webViewApp.postMessage(url1) // ios壳子支付
            window.webkit.messageHandlers.webViewApp2.postMessage(url2) // ios壳子支付
          } catch (err) {
            // window.location.href = 'http:' + configUrl.__gamepayDomain.get() + url //  web跳转支付
            window.location.href = url //  web跳转支付
          }
        } else {
          // window.location.href = 'http:' + configUrl.__gamepayDomain.get() + url //  web跳转支付
          window.location.href = url //  web跳转支付
        }
      }, 500)
    },
    rechargeList (data) {
      // cp点击购买,触发请求得到支付的链接
      let _this = this
      let { amount, roleId, roleName, serverId, serverName, order_id, product_id, cut_pay } = data
      let { name, old_id } = FN.getSession('USER_INFO')

      // 微信内部支付
      function wxpay (config) {
        FN.log('wxpay:', config)
        let {
          appId,
          timeStamp,
          nonceStr,
          signType,
          paySign,
          redirectUrl
        } = config
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId, // 公众号名称，由商户传入
            timeStamp, // 时间戳，自1970年以来的秒数
            nonceStr, // 随机串
            package: config.package,
            signType, // 微信签名方式：
            paySign // 微信签名
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              FN.log('执行微信支付成功', res)
            }
          }
        )
      }
      // 如果切支付,使用马甲游渠道充值方式拉起充值弹框
      window.H5SDK
        .apptoh5({
          cookie_uuid: FN.getLocal('h5sdk').cookie_uuid,
          uid: old_id,
          user_name: name, // string必填用户名
          fee: amount, // int必填充值金额单位分
          server_id: serverId, // int 必填 分服编号
          server_name: serverName, // string 分服名称
          role_id: roleId, // string 必填 角色id
          role_name: roleName, // string 必填 角色名称
          callback_info: order_id, // string 必填 回调信息
          notify_url: 'https:' + configUrl.__h5apiDomain.get('jsLoad') + FN.getSession('FUSE_CHANNEL_INFO').channel+'_notify.php', // string 必通知地址
          // app_name: FN.getSession('FUSE_CHANNEL_INFO').game_name,
          app_name: window.location.href,
          h5sdk_url: window.location.href,
          app_store: 0 // 不是IOS壳包
        })
        .then(res => {
          if (res.code !== 0) return
          if (FN.isWX) {
            wxpay(res.data);
            return;
          }
          _this.fee = res.data.fee;
          _this.pay_list = res.data.list;
        })
    },
    closeRecharge () {
      this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
    }
  }
}
</script>
<style lang="scss" scoped>
#recharge-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9;
}
#recharge-box-mj {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  // transform: translate(-50%, -50%);
  width: 6.4rem;
  background: #fff;
  border-radius: 0.25rem;
  margin-left: -3.2rem;
  margin-top: -2.5rem;
}
#recharge-box-mj h3 {
  text-align: center;
  font-size: 0.4rem;
  line-height: 1.1rem;
  font-weight: normal;
  color: #000;
}
#recharge-box-mj .name {
  font-size: 0.4rem;
  color: #666;
  line-height: 1rem;
  text-align: center;
  background: #f5f5f5;
}
#recharge-box-mj .num {
  line-height: 0.8rem;
  font-size: 0.32rem;
  color: #000;
  text-align: center;
  background: #f5f5f5;
  font-weight: bold;
  margin-bottom: 0.2rem;
}
#recharge-box-mj .num span {
  font-size: 0.3rem;
  color: #000;
}
#recharge-box-mj .list {
}
#recharge-box-mj .list a {
  display: block;
  height: 1.2rem;
  padding-left: 0.5rem;
}
#recharge-box-mj .list img {
  float: left;
  height: 0.75rem;
  width: 0.75rem;
  margin-top: 0.25rem;
}
#recharge-box-mj .list p {
  float: left;
  margin-left: 0.25rem;
  font-size: 0.3rem;
  color: #666;
  line-height: 0.8rem;
}
#recharge-box-mj .close {
  position: absolute;
  width: 0.8rem;
  height: 0.8rem;
  top: 0.15rem;
  right: 0rem;
  background-image: url(../assets/img/close.png);
  background-size: 0.54rem 0.54rem;
  background-repeat: no-repeat;
  background-position: center center;
}
.zhifubao {
  height: 0.85rem;
  line-height: 0.85rem;
  align-items: center;
  padding: 0 0.35rem;
  .icon {
    background-image: url("../assets/img/zhifubao.png");
  }
}
.wechat {
  height: 85rem;
  line-height: 85rem;
  padding: 0.1rem 0 0 0;
  padding: 0 0.35rem;
  .icon {
    background-image: url("../assets/img/wx.png");
  }
}
.list {
  .icon {
    display: inline-block;
    width: 0.8rem;
    height: 0.8rem;
    background-size: 0.8rem 0.8rem;
    float: left;
  }
}
</style>
